import React, {Component} from "react";

class SelectField extends Component {

    onChange(e){
        if (typeof(this.props.onChange) === "function") {
            this.props.onChange(e);
        }
    }

    render() {

        const {id,title,value,options,required} = this.props;

        return (
            <div key={id} className={"inputFieldWrapper selectField"} >
                <label htmlFor={id}>
                    {title}
                </label>
                <select
                    name={id}
                    id={id}
                    value={value}
                    onChange={(e)=>this.onChange(e)}
                    required={required}
                >
                    {
                        options.map((o)=>{
                            return (<option key={o.id} value={o.id}>{o.title}</option>)
                        })
                    }
                </select>
            </div>
        )
    }
}

export default SelectField;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/Form_Elements/SelectField.js